import { InputNumber } from "primereact/inputnumber";
import { Dropdown } from "primereact/dropdown";
import { Tooltip } from "primereact/tooltip";
import {
  ParamCellSlot,
  ParamInputWrap,
  ParamValueSlot,
} from "styles/devices/deviceTable.styles";
import { snapToStep } from "utils/setpointResolution";

interface ParamSetPointCellProps {
  value: number | string | null | undefined;
  pendingValue: number;
  isEditing: boolean;
  min?: number;
  max?: number;
  step?: number;
  suffix?: string;
  disabled?: boolean;
  disabledMessage?: string;
  options?: { label: string; value: number }[];
  inputId: string;
  onValueChange: (value: number) => void;
  hideValue?: boolean;
}

export function ParamSetPointCell({
  value,
  pendingValue,
  isEditing,
  min,
  max,
  step,
  suffix = "",
  disabled = false,
  disabledMessage = "",
  options,
  inputId,
  onValueChange,
  hideValue = false,
}: ParamSetPointCellProps) {
  if (hideValue) {
    return (
      <ParamCellSlot>
        <ParamValueSlot>N/A</ParamValueSlot>
      </ParamCellSlot>
    );
  }

  const displayValue = value === -9999 ? "X" : value;

  return (
    <ParamCellSlot>
      {isEditing ? (
        <>
          {disabled && disabledMessage && (
            <Tooltip
              target={`#${inputId}`}
              content={disabledMessage}
              position="top"
            />
          )}
          <ParamInputWrap id={inputId} $variant={options ? "dropdown" : "number"}>
            {options ? (
              <Dropdown
                value={
                  options.some(
                    (option) => Number(option.value) === Number(pendingValue),
                  )
                    ? Number(pendingValue)
                    : null
                }
                options={options}
                onChange={(e) => onValueChange(Number(e.value))}
                placeholder={
                  pendingValue != null && pendingValue !== 0
                    ? String(pendingValue)
                    : "—"
                }
                disabled={disabled}
              />
            ) : (
              <InputNumber
                value={pendingValue}
                onValueChange={(e) => onValueChange(e.value ?? 0)}
                onBlur={(event) => {
                  if (step == null) return;
                  const raw = event.target.value.replace(/[^\d.-]/g, "");
                  if (raw === "" || raw === "-" || raw === ".") return;
                  const parsed = Number(raw);
                  if (!Number.isFinite(parsed)) return;
                  onValueChange(snapToStep(parsed, step, min, max));
                }}
                min={min}
                max={max}
                step={step}
                suffix={suffix}
                disabled={disabled}
              />
            )}
          </ParamInputWrap>
        </>
      ) : (
        <ParamValueSlot>
          {displayValue}
          {suffix && displayValue !== "X" && displayValue != null
            ? suffix
            : ""}
        </ParamValueSlot>
      )}
    </ParamCellSlot>
  );
}
